export const useDates = () => {
    const getComparableTimeframe = (filterModel, key, compareStrategy = 'year') => {
        return {
            compare: {
                ...filterModel,
                items: filterModel.items.map(item => {
                    if (item.field === key && item.operator == 'between' && typeof item.value == 'object') {
                        const fromDate = new Date(item.value.from);
                        const toDate = new Date(item.value.to);

                        let newFrom;
                        let newTo;

                        if (compareStrategy === 'year') {
                            newFrom = new Date(fromDate);
                            newFrom.setFullYear(newFrom.getFullYear() - 1);
                            newTo = new Date(toDate);
                            newTo.setFullYear(newTo.getFullYear() - 1);
                            newFrom = newFrom.toISOString().split('T')[0];
                            newTo = newTo.toISOString().split('T')[0];
                        } else {
                            const delta = toDate - fromDate;
                            newFrom = new Date(fromDate - delta).toISOString().split('T')[0];
                            newTo = item.value.from;
                        }

                        return {
                            ...item,
                            value: {
                                ...item.value,
                                from: newFrom,
                                to: newTo
                            }
                        };
                    }
                    return item;
                })
            }
        };
    };
    

    return {
        getComparableTimeframe
    }
};
